import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning-sm",
  "use": "icon-warning-sm-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" id=\"icon-warning-sm\"><g stroke=\"currentColor\" fill=\"none\" stroke-linejoin=\"round\"><path d=\"M5.152 1.302l3.244 5.702a.75.75 0 0 1-.652 1.121H1.256a.75.75 0 0 1-.652-1.12l3.244-5.703a.75.75 0 0 1 1.304 0z\" /><path d=\"M4.5 3.5v1\" stroke-linecap=\"round\" /><circle cx=\"4.5\" cy=\"6\" r=\".5\" fill=\"currentColor\" stroke=\"none\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol